import React, { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhatIsBankL from './components/WhatIsBankL';
import WhyBankL from './components/WhyBankL';
import Technology from './components/Technology';
import Infrastructure from './components/Infrastructure';
import Security from './components/Security';
import Roadmap from './components/Roadmap';
import Team from './components/Team';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import './styles/App.css';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <HeroSection />
        <WhatIsBankL />
        <WhyBankL />
        <Technology />
        <Infrastructure />
        <Security />
        <Roadmap />
        <Team />
        <CallToAction />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;